/**
 * @file config.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2025-12-05
 * @modified 2026-04-30
 * @description Central configuration for the Excel Agri client application
 */

// API URL - auto-detect based on current page so the same build works for
// localhost dev, LAN dev (cams-macbook-pro-2.local:3000) and production
// behind an ALB (https://app.excel-agri.com with no port suffix).
const getApiUrl = () => {
  // Explicit override always wins (e.g. build-time REACT_APP_API_URL)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const { protocol, hostname, port, origin } = window.location;

  // Production behind ALB: standard 80/443 ports, no explicit port suffix.
  // The app server is on the same origin — relative API calls just work.
  if (!port || port === '80' || port === '443') {
    return origin;
  }

  // Dev / LAN: frontend on :3000, backend on :3001 of the same host.
  return `${protocol}//${hostname}:3001`;
};

export const API_URL = getApiUrl();
